var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"order_header_title",class:{ ios_header: this.$fn.cookies.getIsios() }},[_c('van-nav-bar',{attrs:{"title":_vm.headtitle,"left-arrow":"","fixed":"","placeholder":"","safe-area-inset-top":""},on:{"click-left":function($event){return _vm.onClickLeft()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }